import type { ILanguageResources, ITranslationModule } from '../../../interfaces';
import { interpolate } from '../../../global';

class Id {
  private constructor() {}
  public static readonly prefix = 'UI.scripts.franchisee.view.FranchiseeInformationView.';

  public static readonly createBranch = `${Id.prefix}createBranch`;
  public static readonly franchiseeBranch = `${Id.prefix}franchiseeBranch`;
}

export class LangFranchiseeInformationView {
  private constructor() {}

  public static createBranch(): string {
    return interpolate(Id.createBranch);
  }
  public static franchiseeBranch(): string {
    return interpolate(Id.franchiseeBranch);
  }
}

export class FranchiseeInformationViewModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(Id.createBranch, "Create {{glossary 'branch'}}", 'Button label for creating a branch');
    register.add(
      Id.franchiseeBranch,
      "{{glossary 'franchisee'}} {{glossary 'branch:plural'}}",
      'Caption for franchisee and branches'
    );
  }
}
